/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Removeaccess1Inputs */

const en_settings_removeaccess1 = /** @type {(inputs: Settings_Removeaccess1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove access`)
};

/**
* | output |
* | --- |
* | "Remove access" |
*
* @param {Settings_Removeaccess1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_removeaccess1 = /** @type {((inputs?: Settings_Removeaccess1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Removeaccess1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_removeaccess1(inputs)
});
export { settings_removeaccess1 as "settings_removeAccess" }